import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { useUserContext } from "../../context/UserProvider";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../firebase";

const profilePicturesContext = createContext(null);
function useProfilePicturesProvider() {
  return useContext(profilePicturesContext);
}

export function ProfilePictureProvider({ children }) {
  const [profilePicturesMap, setProfilePicturesMap] = useState(new Map());
  const pendingRequests = useRef(new Map());
  async function getURL(id) {
    if (!id) return null;
    if (profilePicturesMap.has(id)) return profilePicturesMap.get(id);
    if (pendingRequests.current.has(id)) return pendingRequests.current.get(id);
    // Request url
    const fetchUrl = (async () => {
      // console.log("Getting picture url", id);
      let path = `profile_pictures/${id}`;
      let pictureRef = ref(storage, path);
      try {
        let url = await getDownloadURL(pictureRef);
        setProfilePicturesMap((prev) => {
          const updated = new Map(prev);
          updated.set(id, url);
          return updated;
        });
        return url;
      } catch (err) {
        setProfilePicturesMap((prev) => {
          const updated = new Map(prev);
          updated.set(id, null);
          return updated;
        });
        return null;
      } finally {
        pendingRequests.current.delete(id);
      }
    })();
    pendingRequests.current.set(id, fetchUrl);
    return fetchUrl;
  }
  function setPicturesMap(id, url = null) {
    if (!id) return;
    setProfilePicturesMap(profilePicturesMap.set(id, url));
  }
  return <profilePicturesContext.Provider value={{ getURL, setPicturesMap }}>{children}</profilePicturesContext.Provider>;
}

function ProfilePicture({ userID, name = null, color = " bg-[#4497EA] text-white", className = "", refreshToken = null }) {
  const { user, userDetails } = useUserContext();
  const { getURL } = useProfilePicturesProvider();
  const [pictureURL, setPictureURL] = useState(null);

  useEffect(() => {
    async function getPictureUrl() {
      if (userID) {
        let url = await getURL(userID);
        setPictureURL(url);
      } else if (!userID && !name) {
        let url = await getURL(user.uid);
        setPictureURL(url);
      }
    }
    getPictureUrl();
    if (!pictureURL) {
    }
  }, [refreshToken]);
  if (pictureURL) {
    return (
      <span
        className={
          `aspect-square rounded-full w-[36px] h-[36px] flex items-center justify-center font-medium overflow-clip` + color + className
        }
      >
        <img src={pictureURL} />
      </span>
    );
  }
  if (name)
    return (
      <span className={`aspect-square rounded-full w-[36px] h-[36px] flex items-center justify-center font-medium select-none` + color + className}>
        {name.trim().split(/\s+/)[0][0].toUpperCase() + (name.trim().split(/\s+/)[1]?.[0].toUpperCase() || "")}
      </span>
    );
  return (
    <span className={`aspect-square rounded-full w-[36px] h-[36px] flex items-center justify-center font-medium ` + color + className}>
      {userDetails && userDetails?.firstName[0].toUpperCase() + userDetails?.lastName[0].toUpperCase()}
    </span>
  );
}

export default ProfilePicture;
export { useProfilePicturesProvider };
